import { useEffect, useState } from "react";

import {
  AppTable,
  AppTableCell,
  AppTableHeadCell,
  AppTableRow,
} from "../../../../components/ui";
import Checkbox from "@mui/material/Checkbox/Checkbox";
import { UsersService } from "../../../../api/services/UsersService";
import { ApplicationRole, GetUserListRequest, UserShortResponse } from "../../../../api";

const TABLE_COLUMNS = [
  {
    id: "attorneyName",
    label: "Attorneys",
    sortable: false,
  },
];

interface ShareAttorneysTableProps {
  onAttorneySelectionChange: Function;
}

export default function ShareAttorneysTable(props: ShareAttorneysTableProps) {
  const [selected, setSelected] = useState<readonly number[]>([]);
  const [attorneys, setAttorneys] = useState<UserShortResponse[]>([]);

  useEffect(() => {
    UsersService.postApiUsersGetUsersByRole({
      role: ApplicationRole.ATTORNEY
    } as GetUserListRequest
    ).then((attorneys) => {
      setAttorneys(attorneys);
    });
  }, []);

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelected = attorneys.map((n) => n.id!);
      setSelected(newSelected);
      props.onAttorneySelectionChange(newSelected);
      return;
    }
    setSelected([]);
    props.onAttorneySelectionChange([]);
  };

  const handleClick = (row) => {
    const selectedIndex = selected.indexOf(row.id);
    let newSelected: number[] = [];

    if (selectedIndex === -1) {
      newSelected = selected.concat(row.id);
    } else if (selectedIndex === 0) {
      newSelected = selected.slice(1);
    } else if (selectedIndex === selected.length - 1) {
      newSelected = selected.slice(0, -1);
    } else if (selectedIndex > 0) {
      newSelected = selected
        .slice(0, selectedIndex)
        .concat(selected.slice(selectedIndex + 1));
    }

    setSelected(newSelected);
    props.onAttorneySelectionChange(newSelected);
  };

  const isSelected = (id: number) => selected.indexOf(id) !== -1;

  return (
    <AppTable
      columns={TABLE_COLUMNS}
      showRowNumber={false}
      size="medium"
      leadingHeadCell={
        <AppTableHeadCell padding="checkbox">
          <Checkbox
            color="primary"
            indeterminate={
              selected.length > 0 && selected.length < attorneys.length
            }
            checked={attorneys.length > 0 && selected.length === attorneys.length}
            onChange={handleSelectAllClick}
          />
        </AppTableHeadCell>
      }
      extraColumnCount={1}
      isEmpty={attorneys.length === 0}
      emptyTitle="No attorneys"
    >
      {attorneys.map((row, index) => {
        const isItemSelected = isSelected(row.id!);
        const labelId = `enhanced-table-checkbox-${index}`;

        return (
          <AppTableRow
            onClick={() => handleClick(row)}
            tabIndex={-1}
            key={row.id}
            selected={isItemSelected}
            sx={{ cursor: "pointer" }}
          >
            <AppTableCell padding="checkbox">
              <Checkbox
                color="primary"
                checked={isItemSelected}
                inputProps={{
                  "aria-labelledby": labelId,
                }}
              />
            </AppTableCell>
            <AppTableCell align="left">
              {row.firstName} {row.lastName}
              {row.maxTerminationAgeMonths ? (
                <span className="caption-text d-block">
                  Termination ≤ {row.maxTerminationAgeMonths} mo
                </span>
              ) : null}
            </AppTableCell>
          </AppTableRow>
        );
      })}
    </AppTable>
  );
}
